<script setup>
import { computed } from 'vue';

const props = defineProps({
  title: { type: String, required: true },
  description: { type: String, default: '' },
  variant: {
    type: String,
    default: 'default',
    validator: value => ['default', 'warning', 'danger'].includes(value),
  },
});

const containerClass = computed(
  () =>
    ({
      default: 'bg-n-solid-1 border-n-weak',
      warning: 'bg-n-amber-2 border-n-amber-6',
      danger: 'bg-n-ruby-2 border-n-ruby-6',
    })[props.variant]
);
</script>

<template>
  <div
    class="flex flex-col gap-3 p-4 border rounded-xl sm:flex-row sm:items-center sm:justify-between"
    :class="containerClass"
  >
    <!-- min-w-0 lets the text column shrink below its content, and break-words
         gives long unbroken values (Meta's pfbid ids) somewhere to wrap.
         Without both, the value escapes the card. -->
    <div class="flex flex-col min-w-0 gap-1">
      <span class="text-sm font-medium text-n-slate-12">{{ title }}</span>
      <slot name="description">
        <span v-if="description" class="text-sm break-words text-n-slate-11">
          {{ description }}
        </span>
      </slot>
    </div>
    <div v-if="$slots.default" class="flex-shrink-0">
      <slot />
    </div>
  </div>
</template>
